export default __webpack_public_path__ + "static/media/maure_de_bretagne3.f45c31be.jpg";